import axios from 'axios';

const api = axios.create({
  baseURL: 'https://4byja3g8sa.execute-api.ap-south-1.amazonaws.com/production',
});

// Add request interceptor
api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Add response interceptor to handle 401 errors
api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response && error.response.status === 401) {
      localStorage.removeItem('token');
      window.location.href = '/';
    }
    return Promise.reject(error);
  }
);

export const createSOP = (data) => api.post('/sop/create', data);
export const getSOPTypes = () => api.get('/sop/types');
export const getSOPByType = (type) => api.get(`/sop/${type}`);
export const submitEmployeeSOP = (data) => api.post('/sop/employee/submit', data);

export default api;